import { VXConnector } from "../modules/vx-forms/helpers/vx-api.connector.js";
import { setIsPostalCodeChanged } from "../modules/comparison/module.sharedPostalCodeState.js";
import {initComparison} from '../modules/comparison/module.comparison.js';

let isPostalCodeChanged = false; // Flag to track postal code changes
/*
  * addressSolver
  Vanilla JS implementatie van de address solver met een reguliere template in de CSHTML file in het webproject.
*/
class addressSolverWidget {
  constructor(wrapper) {
    this.postCodeInput = document.getElementById("postalCode");
    this.selectedAddress = document.getElementById("selectedAddress");

    //When using Enter key, move the focus to the address input so it does not trigger the submit
    this.postCodeInput.onkeydown = e => {
      if (e.key === 'Enter') {
        this.selectedAddressRef.focus();
      }
    }

    const handleChange = () => {
      setIsPostalCodeChanged(true);
      this._fetchAddress();
    };
    
    this.postCodeInput.addEventListener("change", handleChange);

    this.selectAddressWrapper = document.getElementById("selectAddressWrapper");

    this.errorText = document.getElementById("errorText");
    this.selectedAddress = null;
    this.isLoading = false;
    this.loadingIcon = document.getElementById("address-solver-loader");

    this.foundAddresses = [];
    this.selectedAddressRef = document.querySelector("#selectedAddress");

    this.selectedAddressRef.addEventListener("change", () => {
      this._selectAddress();
    });

    this.inputRef = document.querySelector("#inputRef");

    this.productType = document.getElementById("hiddenProductType");

    this.postCode = wrapper.dataset.preselectedPostcode;
    this.location = wrapper.dataset.preselectedLocation;
    this.city = wrapper.dataset.preselectedCity;
    if (this.postCode) {
      this.postCodeInput.value = this.postCode;
      this._setPreselectedCity();
    }

    if (this.preselectedCity) {
      this.selectedAddress = decodeURIComponent(this.city);
      this._setPreselectedCity();
    }

    this._fetchAddress();
  }

  async _setPreselectedCity() {
    await this._fetchAddress();

    let options = this.selectedAddressRef.options;
    Array.from(options).forEach((option) => {
      if (option.value == this.location) {
        option.setAttribute("selected", "selected");
      }
    });
  }

  _setLoadingState() {
    this.loadingIcon.hidden = !this.isLoading;
    if (this.isLoading) {
      this.selectAddressWrapper.setAttribute("hidden", "hidden");
    } else {
      this.selectAddressWrapper.removeAttribute("hidden");
    }
  }

  _selectAddress() {
    let select = this.selectedAddressRef;
    let selectedOption = select.options[select.selectedIndex];
    let selectedAddress = selectedOption.dataset.address;

    document.getElementById("hiddenLocationInput").value = "";
    if (selectedAddress) {
      let address = JSON.parse(selectedAddress);

      this.selectedAddress = address.fullName;
      document.getElementById("hiddenLocationInput").value = address.id ?? -1;

      document.getElementById("hiddenLocationInput").dispatchEvent(new Event("change", { bubbles: true }));
      this.errorText.innerHTML = "";
      this.errorText.hidden = true;
      initComparison();
    } else {
      console.log("No address found on selected option");
    }
  }
  _clearAddress() {
    this.selectedAddress = null;
    document.getElementById("hiddenLocationInput").value = "";
  }
  async _fetchAddress() {
    const userPostalCode = this.postCodeInput.value;

    while (this.selectedAddressRef.children.length > 1) {
      this.selectedAddressRef.removeChild(this.selectedAddressRef.lastChild);
    }

    if (userPostalCode.length < 5 || userPostalCode.length > 6) {

      document.getElementById("hiddenLocationInput").value = "";
      this.selectedAddressRef.setAttribute('disabled','disabled');  
      return false;
    }

    this.selectedAddressRef.removeAttribute('disabled');

    this.foundAddresses = [];
    this.isLoading = true;
    this._setLoadingState();
    this.loadingIcon.hidden = false;
    this.errorText.innerHTML = "";
    this.errorText.hidden = true;

    let { data, status } = await VXConnector().getCityDistricts(userPostalCode, this.productType.value);

    if (status == 200) {
      if (data.locationList?.length > 0) {
        this.foundAddresses = data.locationList;
      } else if (data.mainName != null) {
        this.foundAddresses.push({
          fullName: data.mainName,
          id: data.mainId,
        });
      }

      this.foundAddresses.forEach((address) => {
        let option = document.createElement("option");
        option.value = address.fullName;
        option.dataset.address = JSON.stringify(address);
        option.innerText = address.fullName;
        this.selectedAddressRef.appendChild(option);
      });
      Array.from(this.selectedAddressRef.options).forEach((option) => {
        option.removeAttribute("selected");
      });
      setTimeout(() => {
        let firstOption = this.selectedAddressRef.options[1];
        firstOption.setAttribute("selected", "selected");
        this._selectAddress();
      }, 10);
    } else {
      this.errorText.innerHTML = "Es ist ein Fehler aufgetreten. Kontrolieren Sie Ihre Postleitzahl";
      this.errorText.hidden = false;
      var filerSectionYourData = document.getElementById("filter-section__your-data");
      filerSectionYourData != null ? (filerSectionYourData.checked = true) : null;
    }
    this.isLoading = false;
    this._setLoadingState();
  }
}

export { addressSolverWidget };
